import React from 'react';
import { Table, TableBody, Paper, TextField, TableRow, TableCell, IconButton, Button, Tooltip } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { withRouter } from 'react-router'
import { onCheckFormPermission } from '../../../utils_v2';
import { regexConstants } from '../../../constants/regEx';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import { displayDateFormatShort, backendDateFormat } from '../../../constants';
const decimalFields = ['tsn', 'csn', 'avg_fh', 'avg_fc', 'tslsv', 'cslsv',]

export const engineInformationV2 = [
    { key: 'shock_mount_manufacturer', label: 'Shock Mount MFD' },
    { key: 'engine_bag_part_number', label: 'Engine Bag Part Number' },
    { key: 'engine_stand_storage_location', label: 'Engine Stand Storage Location' },
    { key: 'storage_facility_owner', label: 'Storage Facility Owner' },
    { key: 'engine_stand_manufacturer', label: 'Engine Stand MNF' },
    { key: 'engine_stand_part_numbers', label: 'Engine Stand PN' },
    { key: 'engine_stand_serial_numbers', label: 'Engine Stand SN' },
    { key: 'engine_stand_color', label: 'Engine Stand Colour' },

]
export const physicalConditionFiled = [
    { key: 'engine_status', label: 'Engine Status', dropdown: ['On Wing', 'Off Wing'], type: "dropdown" },
    { key: 'serviceability', label: 'Serviceability', dropdown: ['Serviceable', 'UnServiceable'], type: "dropdown" },
    { key: 'aircraft_type', label: 'Aircraft Type', type: "text" },
    { key: 'aircraft_msn', label: 'A/C MSN', type: "text" },
    { key: 'aircraft_reg_no', label: 'A/C Registration', type: "text" },
    { key: 'engine_position', label: 'Engine Position', dropdown: ['1(LH)', '2(RH)', 'N/A'], type: "dropdown" },
    { key: 'removal_date_reason', label: 'Removal Date Reason', type: "text" },
    { key: 'preservation_status', label: 'Preservation Status', type: "text" },
    { key: 'storage_location_conditions', label: 'Storage Location Condition', type: "text" },
    { key: 'engine_pictures_available', label: 'Engine Picture Available', dropdown: ['YES', 'NO'], type: "dropdown" },
    { key: 'stand_pictures_available', label: 'Stand Pictures Available', dropdown: ['YES', 'NO'], type: "dropdown" },
]

const chunkFields = (fields, size) => {
    const rows = []
    for (let i = 0; i < fields.length; i += size) {
        rows.push(fields.slice(i, i + size))
    }
    return rows
}

function EngineInformationV2({ data, onFieldChange, callthisapi, currentFormDetail, formSave, setFormSave, getResponseBack }) {
    const fieldRows_v2 = chunkFields(engineInformationV2, 2)
    const physicalConditionRow = chunkFields(physicalConditionFiled, 2)
    const fh_fc_ratio = Number(data?.engine_information?.avg_fh / data?.engine_information?.avg_fc)
    const getFhFcRatioValue = (data, fhFcRatio) => {
        const storedValue = data?.engine_information?.fh_fc_ratio;
        if (formSave?.type === 'engine_information') {
            if (fhFcRatio === Infinity || isNaN(fhFcRatio) || fhFcRatio === 0 || fhFcRatio === "0" || fhFcRatio === null || fhFcRatio === undefined) {
                return "--";
            } else {
                return Number(fhFcRatio).toFixed(2);
            }
        } else {
            if (fhFcRatio === Infinity || isNaN(fhFcRatio) || fhFcRatio === 0 || fhFcRatio === "0" || fhFcRatio === null || fhFcRatio === undefined) {
                return "--";
            } else {
                if (storedValue !== undefined && storedValue !== null && storedValue !== "") {
                    return storedValue;
                }
            }
        }
        return Number(fhFcRatio).toFixed(2);
    };

    return (
        <section className='form-t015'>
            <Paper square style={{ padding: '10px', marginBottom: "5px" }} elevation={8}>
                <ul className='list-inline'>
                    <li className='list-inline-item'><h4>Engine Information :</h4></li>
                    <li className='list-inline-item' style={{ float: 'right' }}>
                        {!(formSave?.type === 'engine_information' && formSave?.open) && (
                            <Tooltip title="Edit" placement="top">
                                <IconButton disabled={!onCheckFormPermission(currentFormDetail) || formSave?.isdisabled} style={{ cursor: 'pointer' }} color="primary" size="small" onClick={() => setFormSave({ open: true, type: 'engine_information', isdisabled: true })} > <EditIcon /> </IconButton>
                            </Tooltip>
                        )}
                        {formSave?.type === 'engine_information' && (
                            <>
                                <Tooltip title="Cancel" placement="top">
                                    <Button style={{ marginInline: '5px' }} variant="outlined" color="primary" onClick={() => { getResponseBack(); setFormSave({ open: false, type: '', isdisabled: false }); }} size="small" > Cancel </Button>
                                </Tooltip>
                                <Tooltip title="Save" placement="top">
                                    <Button variant="contained" color="primary" onClick={() => { callthisapi('', data); setFormSave({ open: false, type: '', isdisabled: false }); }} size="small" > Save </Button>
                                </Tooltip>
                            </>
                        )}
                    </li>
                </ul>
                <Table className='mui-table-format-t015'>
                    <TableBody>
                        <TableRow>
                            <TableCell><h6>ESN</h6></TableCell>
                            <TableCell >
                                <TextField
                                    variant='outlined'
                                    margin='normal'
                                    id='serial_number'
                                    placeholder="Enter.."
                                    fullWidth
                                    disabled
                                    value={currentFormDetail?.asset?.asset_type === 1 ? currentFormDetail?.asset?.msn : currentFormDetail?.asset?.esn}
                                />
                            </TableCell>
                            <TableCell><h6>Lessee</h6> </TableCell>
                            <TableCell>
                                <Autocomplete
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_info'}
                                    options={[]}
                                    getOptionLabel={option => option}
                                    id="lessee_id"
                                    value={data?.lessee_id || null}
                                    onChange={(e, value) => onFieldChange(e, 'lessee_id', value)}
                                    renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' margin="normal" fullWidth />}
                                />
                            </TableCell>

                        </TableRow>
                        <TableRow>
                            <TableCell><h6>Engine Model</h6></TableCell>
                            <TableCell>
                                <TextField
                                    variant='outlined'
                                    placeholder='Select...'
                                    margin="normal"
                                    fullWidth
                                    disabled
                                    id="model_id"
                                    value={currentFormDetail?.asset?.asset_type === 1 ? currentFormDetail?.asset?.aircraft_type : currentFormDetail?.asset?.engine_type}
                                />
                            </TableCell>
                            <TableCell><h6>Leased TR</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_information'}
                                    variant='outlined'
                                    id='leased_tr'
                                    margin='normal'
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength: 50 }}
                                    value={data?.leased_tr || ''}
                                    onChange={(e) => onFieldChange(e, 'leased_tr', e.target.value ? e.target.value : null)}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell><h6>Operator</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_information'}
                                    variant='outlined'
                                    margin='normal'
                                    id='operator_id'
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength: 50 }}
                                    value={data?.operator_id || ''}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange(e, 'operator_id', e.target.value) }}
                                />
                            </TableCell>
                            <TableCell><h6>QEC KIT Specification</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_information'}
                                    variant='outlined'
                                    margin='normal'
                                    id='has_qec_specification'
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength: 50 }}
                                    value={data?.has_qec_specification || ''}
                                    onChange={(e) => onFieldChange(e, 'has_qec_specification', e.target.value ? e.target.value : null)}
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>
            <Paper square style={{ padding: '10px', marginBottom: "5px" }} elevation={8}>
                <ul className='list-inline'>
                    <li className='list-inline-item'><h4>2.1 Operational Data as of LLP :</h4></li>
                    <li className="list-inline-item" style={{ display: 'inline-flex' }}>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                            <KeyboardDatePicker
                                disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_information'}
                                margin="normal"
                                id="as_of_date_llp"
                                format={displayDateFormatShort}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                value={data?.technical_records?.as_of_date_llp ? data?.technical_records?.as_of_date_llp : null}
                                onChange={(date) => onFieldChange('', 'as_of_date_llp', date ? moment(date).format(backendDateFormat) : null, 'technical_records', '', 'date')}
                                inputVariant='outlined'
                            />
                        </MuiPickersUtilsProvider>
                    </li>
                </ul>
                <Table className='mui-table-format-t015'>
                    <TableBody>
                        <TableRow>
                            <TableCell><h6>TSN</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_information'}
                                    variant='outlined'
                                    margin='normal'
                                    id='tsn'
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength: 10 }}
                                    value={data?.technical_records?.tsn || ''}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); regexConstants.numberWithDot.test(e.target.value) ? onFieldChange(e, 'tsn', e.target.value ? e.target.value : null, 'technical_records') : e.preventDefault() }}
                                />
                            </TableCell>
                            <TableCell><h6>CSN</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_information'}
                                    variant='outlined'
                                    margin='normal'
                                    id='csn'
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength: 10 }}
                                    value={data?.technical_records?.csn || ''}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); regexConstants.onlyNumeric.test(e.target.value) ? onFieldChange(e, 'csn', e.target.value ? e.target.value : null, 'technical_records') : e.preventDefault() }}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell><h6>TSLSV</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_information'}
                                    variant='outlined'
                                    margin='normal'
                                    id='tslsv'
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength: 10 }}
                                    value={data?.engine_information?.tslsv || ''}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); regexConstants.numberWithDot.test(e.target.value) ? onFieldChange(e, 'tslsv', e.target.value ? e.target.value : null, 'engine_information') : e.preventDefault() }}
                                />
                            </TableCell>
                            <TableCell><h6>CSLSV</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_information'}
                                    variant='outlined'
                                    margin='normal'
                                    id='cslsv'
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength: 10 }}
                                    value={data?.engine_information?.cslsv || ''}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); regexConstants.onlyNumeric.test(e.target.value) ? onFieldChange(e, 'cslsv', e.target.value ? e.target.value : null, 'engine_information') : e.preventDefault() }}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell><h6>Max thrust Exceed</h6></TableCell>
                            <TableCell>
                                <Autocomplete
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_information'}
                                    options={[{ id: false, name: "NO" }, { id: true, name: "YES" }]}
                                    getOptionLabel={option => option?.name}
                                    id="is_max_thrust_exceeded"
                                    value={[{ id: false, name: "NO" }, { id: true, name: "YES" }].filter((item => item?.id == data?.technical_records?.is_max_thrust_exceeded))[0] || null}
                                    onChange={(e, value) => onFieldChange(e, 'is_max_thrust_exceeded', value?.id, 'technical_records')}
                                    renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' margin="normal" fullWidth />}
                                />
                            </TableCell>
                            <TableCell><h6>Current Tr</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_information'}
                                    variant='outlined'
                                    margin='normal'
                                    id='current_tr'
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength: 50 }}
                                    value={data?.current_tr || ''}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); regexConstants.numberWithDot.test(e.target.value) ? onFieldChange(e, 'current_tr', e.target.value ? e.target.value : null) : e.preventDefault() }}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell><h6>Operational Region</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_information'}
                                    variant='outlined'
                                    margin='normal'
                                    id='operational_region'
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength: 250 }}
                                    value={data?.engine_information?.operational_region || ''}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange(e, 'operational_region', e.target.value ? e.target.value : null, 'engine_information') }}
                                />
                            </TableCell>
                            <TableCell><h6>Oil Type Used</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_information'}
                                    variant='outlined'
                                    margin='normal'
                                    id='oil_type_used'
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength: 250 }}
                                    value={data?.engine_information?.oil_type_used || ''}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange(e, 'oil_type_used', e.target.value ? e.target.value : null, 'engine_information') }}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell><h6>Oil Consumption (QTZ/HR)</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_information'}
                                    variant='outlined'
                                    margin='normal'
                                    id='oil_consumption_qtz_hr'
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength: 250 }}
                                    value={data?.engine_information?.oil_consumption_qtz_hr || ''}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange(e, 'oil_consumption_qtz_hr', e.target.value ? e.target.value : null, 'engine_information') }}
                                />
                            </TableCell>
                            <TableCell><h6>Fuel Type / SAF Usage</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_information'}
                                    variant='outlined'
                                    margin='normal'
                                    id='fuel_type_saf_usage'
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength: 250 }}
                                    value={data?.engine_information?.fuel_type_saf_usage || ''}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange(e, 'fuel_type_saf_usage', e.target.value ? e.target.value : null, 'engine_information') }}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell><h6>Last Reported EGTM</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_information'}
                                    variant='outlined'
                                    margin='normal'
                                    id='last_reported_egtm'
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength:50 }}
                                    value={data?.engine_information?.last_reported_egtm || ''}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange(e, 'last_reported_egtm', e.target.value ? e.target.value : null, 'engine_information') }}
                                />
                            </TableCell>
                            <TableCell><h6>Expected EGTM Loss per 1000FC</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_information'}
                                    variant='outlined'
                                    margin='normal'
                                    id='expected_egtm_loss_per_1000fc'
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength:10 }}
                                    value={data?.engine_information?.expected_egtm_loss_per_1000fc || ''}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange(e, 'expected_egtm_loss_per_1000fc', e.target.value ? e.target.value : null, 'engine_information') }}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell><h6>Avg FH</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_information'}
                                    variant='outlined'
                                    margin='normal'
                                    id='avg_fh'
                                    placeholder="Enter.."
                                    fullWidth
                                    value={data?.engine_information?.avg_fh || ''}
                                    inputProps={{ maxLength:5 }}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); regexConstants.numberWithDot.test(e.target.value) ? onFieldChange(e, 'avg_fh', e.target.value ? e.target.value : null, 'engine_information') : e.preventDefault() }}
                                />
                            </TableCell>
                            <TableCell><h6>Avg FC</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_information'}
                                    variant='outlined'
                                    margin='normal'
                                    id='avg_fc'
                                    placeholder="Enter.."
                                    fullWidth
                                    value={data?.engine_information?.avg_fc || ''}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        const numericValue = value?.replace(/[^0-9.]/g, '');
                                        const dotCount = (numericValue.match(/\./g) || []).length;
                                        let isValid = false;
                                        if (dotCount > 1) {
                                            isValid = false;
                                        } else if (numericValue === '') {
                                            isValid = true;
                                        } else {
                                            const [integerPart, fractionalPart = ''] = numericValue?.split('.');
                                            const intLenOk = integerPart?.length <= 5;
                                            const decLenOk = fractionalPart?.length <= 2;
                                            const isNum = /^\d{1,5}(\.\d{0,2})?$/.test(numericValue);
                                            isValid = intLenOk && decLenOk && isNum;
                                        }
                                        if (isValid || value === '') {
                                            onFieldChange(e, 'avg_fc', value ? numericValue : null, 'engine_information');
                                        }
                                    }}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell><h6>FH/FC Ratio</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled
                                    variant='outlined'
                                    margin='normal'
                                    id='fh_fc_ratio'
                                    placeholder="Enter.."
                                    fullWidth
                                    // value={data?.engine_information?.fh_fc_ratio || ''}
                                    value={getFhFcRatioValue(data, fh_fc_ratio)}
                                />
                            </TableCell>
                            <TableCell><h6>Average Derate %</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_information'}
                                    variant='outlined'
                                    margin='normal'
                                    id='engine_avg_derate_percentage'
                                    value={data?.engine_information?.engine_avg_derate_percentage || ''}
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength: !regexConstants.numberWithDot.test(data?.engine_information?.engine_avg_derate_percentage) && 3 }}
                                    onChange={(e) => { // source chatgpt
                                        const value = e.target.value;
                                        const numericValue = value?.replace(/[^\d.]/g, '');
                                        const dotCount = (numericValue.match(/\./g) || [])?.length;
                                        let isValid = false;
                                        if (dotCount > 1) {
                                            isValid = false;
                                        } else if (numericValue === '') {
                                            isValid = true;
                                        } else if (dotCount === 1) {
                                            const [integerPart, fractionalPart = ''] = numericValue?.split('.');
                                            const integerNum = integerPart === '' ? 0 : parseInt(integerPart, 10);
                                            const num = parseFloat(numericValue);
                                            isValid = (
                                                integerPart?.length <= 3 &&
                                                integerNum <= 100 &&
                                                fractionalPart?.length <= 2 &&
                                                num <= 100 &&
                                                regexConstants.numberWithDot.test(numericValue)
                                            );
                                        } else {
                                            const integerNum = parseInt(numericValue, 10);
                                            isValid = (
                                                numericValue.length <= 3 &&
                                                integerNum <= 100 &&
                                                regexConstants.numberWithDot.test(numericValue)
                                            );
                                        }
                                        if (isValid || value === '') {
                                            onFieldChange(e, 'engine_avg_derate_percentage', value ? numericValue : null, 'engine_information');
                                        }
                                    }}
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>
            <Paper square style={{ padding: '10px', marginBottom: "5px" }} elevation={8}>
                <Table className='mui-table-format-t015'>
                    <TableBody>
                        <TableRow>
                            <TableCell>
                                <h6 style={{ display: "contents" }}>
                                    <span style={{ marginRight: '30px' }}>Operating as</span>
                                    <TextField
                                        disabled
                                        variant='outlined'
                                        margin='normal'
                                        id='current_tr'
                                        placeholder="Enter.."
                                        // fullWidth
                                        value={data?.current_tr || ''}
                                    />
                                </h6>
                            </TableCell>
                            <TableCell><h6>Description</h6></TableCell>
                            <TableCell><h6>FC to go</h6></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell><h6>The LLP with the lowest remaning life is</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_information'}
                                    variant='outlined'
                                    margin='normal'
                                    id='llp_lowest_remaining_life_description'
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength: 250 }}
                                    value={data?.engine_information?.llp_lowest_remaining_life_description || ''}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange(e, 'llp_lowest_remaining_life_description', e.target.value ? e.target.value : null, 'engine_information') }}
                                />
                            </TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_information'}
                                    variant='outlined'
                                    margin='normal'
                                    id='llp_lowest_remaining_life_fc_to_go'
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength:10 }}
                                    value={data?.engine_information?.llp_lowest_remaining_life_fc_to_go || ''}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange(e, 'llp_lowest_remaining_life_fc_to_go', e.target.value ? e.target.value : null, 'engine_information') }}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell><h6>The limiting LLP in the hot section is</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_information'}
                                    variant='outlined'
                                    margin='normal'
                                    id='llp_hot_section_description'
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength: 250 }}
                                    value={data?.engine_information?.llp_hot_section_description || ''}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange(e, 'llp_hot_section_description', e.target.value ? e.target.value : null, 'engine_information') }}
                                />
                            </TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_information'}
                                    variant='outlined'
                                    margin='normal'
                                    id='llp_hot_section_fc_to_go'
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength:10 }}
                                    value={data?.engine_information?.llp_hot_section_fc_to_go || ''}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange(e, 'llp_hot_section_fc_to_go', e.target.value ? e.target.value : null, 'engine_information') }}
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>
            <Paper square style={{ padding: '10px', marginBottom: "5px" }} elevation={8}>
                <ul className='list-inline'>
                    <li className='list-inline-item'><h4>2.2 Engine Trasnport Equipment :</h4></li>
                </ul>
                <Table className='mui-table-format-t015'>
                    <TableBody>
                        {fieldRows_v2.map((row, rowIndex) => (
                            <TableRow key={rowIndex}>
                                {row.map(field => (
                                    <React.Fragment key={field.key}>
                                        <TableCell><h6>{field.label}</h6></TableCell>
                                        <TableCell>
                                            <TextField
                                                disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_information' || (field.key === 'fh_fc_ratio')}
                                                variant='outlined'
                                                margin='normal'
                                                id={field.key}
                                                placeholder="Enter.."
                                                fullWidth
                                                inputProps={{ maxLength: 250 }}
                                                value={data?.engine_information?.[field.key] || ''}
                                                onChange={(e) => {
                                                    e.preventDefault(); e.stopPropagation();
                                                    if (decimalFields.includes(field.key) && !regexConstants.numberWithDot.test(e.target.value)) { return }
                                                    onFieldChange(e, field.key, e.target.value ? e.target.value : null, 'engine_information')
                                                }}
                                            />
                                        </TableCell>
                                    </React.Fragment>
                                ))}
                                {row.length < 2 ? <><TableCell></TableCell><TableCell></TableCell></> : null}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>


            <Paper square style={{ padding: '10px', marginBottom: "5px" }} elevation={8}>
                <ul className='list-inline'>
                    <li className='list-inline-item'><h4>2.3 Physical Condition at Time of Inspection :</h4></li>
                </ul>
                <Table className='mui-table-format-t015'>
                    <TableBody>
                        {physicalConditionRow.map((row, rowIndex) => (
                            <TableRow key={rowIndex}>
                                {row.map(field => (
                                    <React.Fragment key={field.key}>
                                        <TableCell><h6>{field.label}</h6></TableCell>
                                        <TableCell>
                                            {field.type === 'dropdown' ? (
                                                <Autocomplete
                                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_information'}
                                                    options={field.dropdown || []}
                                                    getOptionLabel={option => option}
                                                    id={field.key}
                                                    value={data?.engine_information?.[field.key] || null}
                                                    onChange={(e, value) => onFieldChange(e, field.key, value, 'engine_information')}
                                                    renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' margin="normal" fullWidth />}
                                                />
                                            ) : (
                                                <TextField
                                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_information'}
                                                    variant='outlined'
                                                    margin='normal'
                                                    id={field.key}
                                                    placeholder="Enter.."
                                                    fullWidth
                                                    inputProps={{ maxLength: 250 }}
                                                    value={data?.engine_information?.[field.key] || ''}
                                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange(e, field.key, e.target.value ? e.target.value : null, 'engine_information') }}
                                                />
                                            )}
                                        </TableCell>
                                    </React.Fragment>
                                ))}
                                {row.length < 2 ? <><TableCell></TableCell><TableCell></TableCell></> : null}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
        </section>
    );
}

export default withRouter(EngineInformationV2)
